// Product card image slider: swipe on touch, arrows on hover, dots follow the current image.
// Slides 3+ arrive without src (data-cymbru-src/srcset) and load when the shopper reaches for the slider.
if (!customElements.get('cymbru-card-slider')) {
  customElements.define(
    'cymbru-card-slider',
    class CymbruCardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cymbru-card-slider__track');
        this.dots = Array.from(this.querySelectorAll('.cymbru-card-slider__dot'));
        if (!this.track || this.dots.length < 2) return;

        const loadSlides = () => this.loadSlides();
        ['pointerenter', 'touchstart', 'focusin'].forEach((type) =>
          this.addEventListener(type, loadSlides, { once: true, passive: true })
        );

        this.querySelectorAll('.cymbru-card-slider__button').forEach((button) =>
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.loadSlides();
            this.go(Number(button.dataset.direction));
          })
        );

        this.track.addEventListener(
          'scroll',
          () => {
            this.loadSlides();
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          },
          { passive: true }
        );
      }

      loadSlides() {
        if (this.slidesLoaded) return;
        this.slidesLoaded = true;
        this.querySelectorAll('img[data-cymbru-src]').forEach((img) => {
          if (img.dataset.cymbruSrcset) img.srcset = img.dataset.cymbruSrcset;
          img.src = img.dataset.cymbruSrc;
          img.removeAttribute('data-cymbru-src');
          img.removeAttribute('data-cymbru-srcset');
        });
      }

      get index() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      go(direction) {
        const count = this.dots.length;
        const next = (this.index + direction + count) % count;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'smooth' });
      }

      update() {
        const current = this.index;
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      }
    }
  );
}
